import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Activity, Zap, Star } from 'lucide-react';
import { Member } from '@/types/member';
import { UserStatus } from '@/types/presence';

interface HotLeadIndicatorsProps {
  member: Member;
  userStatus: UserStatus;
  compatibilityScore?: number;
}

export const HotLeadIndicators: React.FC<HotLeadIndicatorsProps> = ({ 
  member, 
  userStatus, 
  compatibilityScore = 0 
}) => {
  const isNewMember = member.created_at && 
    new Date(member.created_at) > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);

  return (
    <div className="flex gap-1 items-center flex-wrap">
      {/* Actif maintenant */}
      {userStatus === 'available' && (
        <Badge className="bg-green-500 text-white text-[10px] px-1.5 py-0.5 gap-1 border-0">
          <Activity className="w-3 h-3" />
          Actif
        </Badge>
      )}
      
      {/* Matching parfait (80%+) */}
      {compatibilityScore >= 80 && (
        <Badge className="bg-purple-500 text-white text-[10px] px-1.5 py-0.5 gap-1 border-0">
          <Zap className="w-3 h-3" />
          Match parfait
        </Badge>
      )}
      
      {/* Nouveau membre (7 jours) */}
      {isNewMember && (
        <Badge variant="outline" className="text-[10px] px-1.5 py-0.5 gap-1 border-blue-500 text-blue-600 bg-blue-50">
          <Star className="w-3 h-3" />
          Nouveau
        </Badge>
      )}
    </div>
  );
};
